var map = {
	"./Project/resources/components/canvas/blocks/modules/projectSlider/admin/BlockPanel.vue": 42723,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/admin/LoopItemPanel.vue": 56155,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/block.js": 19882,
	"./Project/resources/components/website/modules/projects/index.js": 32613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31335;